'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _react = require('react');

var propTypes = exports.propTypes = {
  className: _react.PropTypes.string,
  classNames: _react.PropTypes.object,
  columns: _react.PropTypes.array,
  components: _react.PropTypes.object,
  rows: _react.PropTypes.array,
  rowKey: _react.PropTypes.string,
  tableWidth: _react.PropTypes.any.isRequired,
  tableHeight: _react.PropTypes.any.isRequired,
  searchable: _react.PropTypes.bool,
  reorderColumns: _react.PropTypes.bool,
  sortable: _react.PropTypes.bool,
  addAction: _react.PropTypes.bool,
  deleteAction: _react.PropTypes.bool,
  onSelectRow: _react.PropTypes.func,
  pagination: _react.PropTypes.object,
  onMoveColumns: _react.PropTypes.func,
  onAdd: _react.PropTypes.func,
  onDelete: _react.PropTypes.func,
  onEdit: _react.PropTypes.func,
  onConfirmEdit: _react.PropTypes.func,
  onRow: _react.PropTypes.func,
  onPropertyChange: _react.PropTypes.func,
  tableLayout: _react.PropTypes.string
};

var defaultProps = exports.defaultProps = {
  classNames: {
    table: null,
    header: {
      wrapper: null
    },
    body: {
      wrapper: null
    }
  },
  styles: {
    resize: {
      container: {},
      value: {},
      handle: {}
    },
    sort: {
      container: {},
      value: {},
      order: {}
    }
  },
  components: {},
  tableLayout: 'fixed',
  onAdd: function onAdd() {},
  onDelete: function onDelete() {},
  onEdit: function onEdit() {},
  onConfirmEdit: function onConfirmEdit() {},
  onRow: function onRow() {
    return {};
  },
  onDragColumn: function onDragColumn() {},
  onMoveColumns: function onMoveColumns() {},
  onSort: function onSort() {},
  onSelectRow: function onSelectRow() {}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTable/EnterpriseTableProps.js
// module id = 1610
// module chunks = 0